import { combineReducers } from 'redux';
import { RootAction } from '@src/app/_redux';
import {
  PAYMENTS_LOADING,
  PAYMENTS_SUCCESS,
  PAYMENTS_ERROR,
  PAYMENTS_CANCEL,
  PAYMENTS_START,
} from '@src/app/accounts/payments/actions';

export type State = {
  readonly loading: boolean;
  paymentsResult: Object | null;
};

export const reducer = combineReducers<State, RootAction>({
  loading: (state = false, action) => {
    switch (action.type) {
      case PAYMENTS_SUCCESS:
      case PAYMENTS_ERROR:
      case PAYMENTS_CANCEL:
        return false;
      case PAYMENTS_LOADING:
        return action.payload;
      default:
        return state;
    }
  },

  paymentsResult: (state = null, action) => {
    switch (action.type) {
      case PAYMENTS_SUCCESS:
      case PAYMENTS_ERROR:
        return action.payload;
      case PAYMENTS_CANCEL:
      case PAYMENTS_START:
        return null;
      default:
          return state;
    }
  },
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/payments/reducer.ts